import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph"},[_c('div',{staticClass:"progress-line"},[_vm._v(_vm._s(_vm.percentageComplete)+"%")]),_c(VProgressLinear,{attrs:{"color":_vm.getProgressBarColorClass,"value":_vm.percentageComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }